import { NavLink } from "react-router-dom"
import { useSelector } from 'react-redux'
import { RootState } from '../../store/configure-store'

export interface SubPage {
    label: string
    route: string
}

interface NavHeaderProps {
    subPages: SubPage[]
    preserveCompany?: boolean
}

export const NavHeader: React.FC<NavHeaderProps> = ({ subPages, preserveCompany = true }) => {
    const company = useSelector((state: RootState) => state.companyName.value)

    return <nav className="nav-header">
        <ul className="clean-list">
            {subPages.map(page => <li key={page.route}>
                <NavLink to={preserveCompany && company ? `${page.route}?company=${company}` : page.route}>{page.label}</NavLink>
            </li>)}
        </ul>
    </nav>
}